import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class MaintenancePageGuard implements CanActivate {
  constructor(
    private router: Router,
    private localizeRouterService: LocalizeRouterService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!environment.maintenanceMode) {
      // Rediriger vers la page d'accueil (localisée) si le mode maintenance n'est pas actif
      const localizedHome = this.localizeRouterService?.translateRoute('/') as string | undefined;
      const url = localizedHome && typeof localizedHome === 'string' ? localizedHome : '/';
      return this.router.parseUrl(url);
    }
    // Autoriser l'accès à la page de maintenance si le mode maintenance est actif
    return environment.maintenanceMode;
  }
}
